import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";
import { buildColortypeUserPhotoContinueUrl } from "./colortypeUserPhotoContinue";

const FaceMeshV2Page = () => (
  <FaceMeshAsyncV2Page
    buildContinueUrlOverride={buildColortypeUserPhotoContinueUrl}
    continueUrl="/colortype-3month-29-upsell"
  />
);

export default FaceMeshV2Page;
